/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";

/**
 * The properties used by all Ab Initio React input components.
 */

/**
 * Extracts AbInputProps fields, excluding fields that are NOT part of the AbInputProps definition.
 * 
 * When your prop type extends AbInputProps, use this method to extract only those input
 * props before spreading them into a component you are rendering. This can help defend against
 * spreading unintended props into that rendered component.
 */
export const extractInputProps = props => {
  const commonProps = ReactUtils.extractCommonProps(props);
  const {
    name,
    disabled,
    tabIndex,
    tooltip,
    autoFocus
  } = props;
  return {
    ...commonProps,
    name,
    disabled,
    tabIndex,
    tooltip,
    autoFocus
  };
};
//# sourceMappingURL=AbInputProps.js.map
